import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

@Component({
  selector: 'pos-app-lib-customer-privacy-info',
  templateUrl: './customer-privacy-info.component.html',
  styleUrls: ['./customer-privacy-info.component.scss'],
})
export class CustomerPrivacyInfoComponent {
  otherButton: { action: Observable<any>; text: string } = null;
  constructor(public activeModal: NgbActiveModal) {}
  onOtherButton() {
    this.activeModal.close(true);
  }
}
